import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import Spacing from '@marvelapp/marvel-ui/spacing';
import Heading from '@marvelapp/marvel-ui/heading';
import Paragraph from '@marvelapp/marvel-ui/paragraph';
import Align from '@marvelapp/marvel-ui/align';

import Image from 'marketing-website/components/modules/Image';

import styles from './style/security-card.module.css';

const cx = classNames.bind({ ...styles });

const bgValues = [
  'teal',
  'marvel',
  'purple--l',
  'orange--l',
  'yellow--l',
  'purple',
];

export default function SecurityCard({
  title,
  subtitle,
  color,
  raised,
  image,
}) {
  const blockClasses = cx('flex', { raised });
  const circleClasses = cx(`bg-${color}`, 'circle');
  return (
    <div className={blockClasses}>
      <div className={circleClasses}>
        <Image hasShadow={false} {...image} />
      </div>
      <div className={styles.content}>
        <Align type="left">
          <Spacing size="xxs" type="margin" position="bottom">
            <Heading tag="h3" weight="bold" size="m" color="black">
              {title}
            </Heading>
          </Spacing>
          <Paragraph size="m" color="silver">
            {subtitle}
          </Paragraph>
        </Align>
      </div>
    </div>
  );
}

SecurityCard.propTypes = {
  title: PropTypes.string.isRequired,
  raised: PropTypes.bool,
  color: PropTypes.oneOf(bgValues).isRequired,
  subtitle: PropTypes.string.isRequired,
  image: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/modules/SecuritySection/SecurityCard.js